var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogContainer',{attrs:{"showDialog":_vm.showDialog,"title":"Edit Client","icon":"edit","toolbarActions":[
    {
      text: 'Save',
      icon: 'save',
      buttonColor: 'success',
      emitEvent: 'onSubmitClicked',
      showIsLoading: true,
      isDisabledFunc: () => !_vm.isFormValid,
    },
    {
      text: 'Cancel',
      depressed: true,
      emitEvent: 'onCancelClicked',
    },
  ],"isLoading":_vm.isLoading},on:{"onCancelClicked":_vm.onCancelClicked,"onSubmitClicked":_vm.onSubmitClicked}},[_c('v-container',{attrs:{"pa-0":"","grid-list-lg":""}},[_c('v-form',{ref:"form",model:{value:(_vm.isFormValid),callback:function ($$v) {_vm.isFormValid=$$v},expression:"isFormValid"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('ControlCheckbox',{attrs:{"label":"Enabled?","disabled":_vm.isLoading},model:{value:(_vm.isEnabled),callback:function ($$v) {_vm.isEnabled=$$v},expression:"isEnabled"}})],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }